export default __webpack_public_path__ + "static/media/ellip_search.89b83622.svg";